import React from 'react';
import {Link} from 'react-router-dom';

export default function (props) {
    return(
        <section className="bg-light flex-center py-4 pt-5 pb-15">
            <div className="container pb-15">
                <h4 className="text-center mt-8">Tu cuenta no tiene permisos de administrador</h4>
                <h5 className="text-center mt-5">Puede ser que tu configuraction como administrador este tomando algo de tiempo</h5>
                <p className="text-center mt-8"><Link to="/" className="btn-dark p-4">INICIO</Link></p>
            </div>
        </section>
    );
}


// WEBPACK FOOTER //
// ./src/admin/components/dashboard/NotAllowed.js